import ModalCustom from "./Modal";
import { useState, useMemo } from "react";
import eventsData from "./../events.json";
import ciro from "../../assets/images/ciro/ciro1.jpg";
import cruzandoElCharco from "../../assets/images/fotosAColor/cruzandoColor.jpg";
import fundamentalistasFondo from "../../assets/images/fotosAColor/fundamentalistasColor.jpg";
import guasones from "../../assets/images/fotosAColor/guasonesColor.jpg";
import elmato from "../../assets/images/fotosAColor/elMatoColor.jpg";
import lostotora from "../../assets/images/fotosAColor/losTotoraColor.png";
import verEventoBlanco from "../../assets/img/verEventoBlanco.svg";
import verEventoNegro from "../../assets/img/verEventoNegro.svg";

const parseEventDate = (dateStr) => {
	const parts = dateStr.split("-");
	const day = parseInt(parts[0]);
	const month = parseInt(parts[1]) - 1;
	const year =
		parts[2] && parts[2].length === 2
			? parseInt("20" + parts[2])
			: parseInt(parts[2]);
	return new Date(year, month, day);
};

const STATIC_EVENTS = [
	{
		imgSrc: "ciro",
		alt: "ciro",
		title: "CIRO Y LOS PERSAS",
		modalTitle: "ciro",
		dates: [
			"3/11 Barcelona Razzmatazz - SOLD OUT",
			"4/11 Valencia Sala Repvblicca - SOLD OUT",
			"6/11 Mallorca Es Gremi - SOLD OUT",
			"10/11 Alicante Sala The One - SOLD OUT",
			"11/11 Málaga Sala Paris 15 - SOLD OUT",
			"13/11 Madrid Sala Riviera - SOLD OUT"
		]
	},
	{
		imgSrc: "cruzando",
		alt: "cruzando",
		title: "CRUZANDO EL CHARCO",
		modalTitle: "cruzando",
		dates: [
			"6/10 Madrid Sala Independance",
			"7/10 Valencia Peter Rock Club",
			"9/10 Barcelona Razzmatazz - SOLD OUT"
		]
	},
	{
		imgSrc: "lostotora",
		alt: "lostotora",
		title: "LOS TOTORA",
		modalTitle: null,
		dates: [
			"8/9 Madrid Sala Cafe Berlin - SOLD OUT",
			"9/9 Alicante Sala The One",
			"17/9 Barcelona Sala Wolf - SOLD OUT"
		]
	},
	{
		imgSrc: "elmato",
		alt: "elmato",
		title: "EL MATO A UN POLICIA MOTORIZADO",
		modalTitle: null,
		dates: ["2/7 Mallorca Es Gremi", "10/7 Málaga Sala Trinchera"]
	},
	{
		imgSrc: "guasones",
		alt: "guasones",
		title: "GUASONES",
		modalTitle: null,
		dates: [
			"26/5 Barcelona Razzmatazz - SOLD OUT",
			"27/5 Mallorca Es Gremi",
			"28/5 Valencia Madison Club",
			"3/6 Málaga Sala Trinchera",
			"4/6 Madrid Sala Independance"
		]
	},
	{
		imgSrc: "fundamentalistas",
		alt: "fundamentalistas",
		title: "LOS FUNDAMENTALISTAS DEL AIRE ACONDICIONADO",
		modalTitle: "fundamentalistas",
		dates: [
			"31/4 Barcelona Razzmatazz - SOLD OUT",
			"2/4 Mallorca Es Gremi",
			"7/4 Madrid Sala Riviera",
			"8/4 Valencia Sala Repvblicca - SOLD OUT",
			"9/4 Málaga Sala Paris 15 - SOLD OUT"
		]
	}
];

const staticImages = {
	ciro,
	cruzando: cruzandoElCharco,
	fundamentalistas: fundamentalistasFondo,
	guasones,
	elmato,
	lostotora
};

const Eventos = () => {
	const [activeModal, setActiveModal] = useState(null);

	const handleOpen = (title) => setActiveModal(title);
	const handleClose = () => setActiveModal(null);

	const pastTours = useMemo(() => {
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const cutoff = new Date(today);
		cutoff.setDate(cutoff.getDate() - 2);

		const toursMap = new Map();
		const pastSingles = [];

		eventsData.forEach((event) => {
			if (event.is_gira) {
				if (parseEventDate(event.date) < cutoff) {
					if (!toursMap.has(event.band)) {
						toursMap.set(event.band, {
							band: event.band,
							band_name: event.band_name,
							tour_name: event.tour_name,
							flyer_gira: event.flyer_gira,
							events: [],
							isSingle: false
						});
					}
					toursMap.get(event.band).events.push(event);
				}
			} else {
				if (parseEventDate(event.date) < cutoff) {
					pastSingles.push({ ...event, isSingle: true });
				}
			}
		});

		toursMap.forEach((tour) => {
			tour.events.sort((a, b) => parseEventDate(a.date) - parseEventDate(b.date));
		});

		const tours = Array.from(toursMap.values());
		const singles = pastSingles.map((e) => ({
			...e,
			sortDate: parseEventDate(e.date)
		}));
		const toursWithDate = tours.map((t) => ({
			...t,
			sortDate: parseEventDate(t.events[0].date)
		}));

		return [...toursWithDate, ...singles].sort((a, b) => b.sortDate - a.sortDate);
	}, []);

	const totalDynamic = pastTours.length;

	return (
		<section className='flex section-fechas'>
			{pastTours.map((item, index) => {
				const colorId = index % 2 === 0 ? "negro" : "blanco";
				if (item.isSingle) {
					return (
						<div key={`single-${item.alt}-${index}`} className='row row-fechas g-0'>
							<div className='col-sm'>
								<img
									src={item.src}
									alt={item.alt}
									className='w-100'
									id='imagenAColor'
								/>
							</div>
							<div className='col-sm' id={colorId}>
								<div className='col-sm' id='div-fechas'>
									<h1 className='title-fecha'>{item.titulo.toUpperCase()}</h1>
									<h4 className='date-fecha'>
										{item.fecha} · {item.lugar} · {item.venue}
									</h4>
								</div>
							</div>
						</div>
					);
				}
				return (
					<div key={item.band} className='row row-fechas g-0'>
						<div className='col-sm'>
							<img
								src={item.flyer_gira}
								alt={item.band_name}
								className='w-100'
								id='imagenAColor'
							/>
						</div>
						<div className='col-sm' id={colorId}>
							<div className='col-sm' id='div-fechas'>
								<h1 className='title-fecha'>
									{item.band_name.toUpperCase()}
								</h1>
								{item.events.map((event, i) => (
									<h4 key={i} className='date-fecha'>
										{event.fecha} · {event.lugar} · {event.venue}
									</h4>
								))}
							</div>
						</div>
					</div>
				);
			})}
			{STATIC_EVENTS.map((entry, index) => {
				const colorId =
					(totalDynamic + index) % 2 === 0
						? "negro"
						: "blanco";
				const verEvento =
					colorId === "negro"
						? verEventoBlanco
						: verEventoNegro;
				return (
					<div
						key={entry.title}
						className='row row-fechas g-0'>
						<div className='col-sm'>
							<img
								src={
									staticImages[
										entry
											.imgSrc
									]
								}
								alt={entry.alt}
								className='w-100'
								id='imagenAColor'
								onClick={
									entry.modalTitle
										? () =>
												handleOpen(
													entry.modalTitle
												)
										: undefined
								}
								style={
									entry.modalTitle
										? {
												cursor: "pointer"
										  }
										: {}
								}
							/>
						</div>
						<div
							className='col-sm'
							id={colorId}>
							<div
								className='col-sm'
								id='div-fechas'>
								<h1 className='title-fecha'>
									{
										entry.title
									}
								</h1>
								{entry.dates &&
									entry.dates.map(
										(
											date,
											i
										) => (
											<h4
												key={
													i
												}
												className='date-fecha'>
												{
													date
												}
											</h4>
										)
									)}
								{entry.modalTitle && (
									<button
										onClick={() =>
											handleOpen(
												entry.modalTitle
											)
										}>
										<img
											src={
												verEvento
											}
											width={
												60
											}
											height={
												60
											}
											alt='ver evento'
										/>
									</button>
								)}
							</div>
						</div>
					</div>
				);
			})}
			<ModalCustom
				show={activeModal !== null}
				handleClose={handleClose}
				title={activeModal}
			/>
		</section>
	);
};
export default Eventos;
